<template>
    <hr class="divider" :class="classes.divider" />
</template>

<script setup lang="ts">
interface Classes {
    divider?: string;
}

interface Props {
    classes?: Classes;
}

withDefaults(defineProps<Props>(), {
    classes: () => ({
        divider: '',
    }),
});
</script>

<style lang="scss" scoped>
.divider {
    border: 0;
    height: 1px;
    background-color: var(--color-dark);
    margin: 1rem 0;
}
</style>
